import React from "react";
import { Flow } from "flow-react";
import { observer } from "mobx-react";
import { connect } from "react-redux";
import MainPage from "pages/MainPage/MainPage";
import { IntlProvider } from "react-intl";
import locale_en from "assets/languages/en";
import locale_de from "assets/languages/de";
import * as actions from "store/actions";
import Navigation from "layouts/Navigation/Navigation";
import { getBaseName } from "helpers/AppHelper";
import * as ConfigTypes from "config/ConfigTypes";
import Footer from "layouts/Footer/Footer";

import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import "./App.css";

const data = {
  de: locale_de,
  en: locale_en,
};

const App = observer(
  class App extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        baseName: getBaseName(),
      };
    }

    getConfig = () => {
      try {
        import("config/Metadata.js")
          .then((config) => {
            if (config && config.object && config.object.length) {
              let objectMeta = config.object.map((item) => {
                return item;
              });
              this.props.updateMediaObjects({
                objectMeta,
                initApp: true,
                //config
              });

              this.props.updateConfigObjects({
                config
              });
            }
          })
          .catch((err) => console.log("LOGS: getConfig err", err));
      } catch (err) {
        console.log("LOGS: getConfig Error", err);
      }
    };

    getInstConfig = () => {
      try {
        import("config/CustomerConfig.js")
          .then((config) => {
            if (config && config.instconfig && config.instconfig.length) {
              // let instconfig = config.instconfig.map((item) => {
              //   return item;
              // });
              this.props.updateConfigObjects({
                customerConfig: {
                  instconfig: config.instconfig,
                  userconfig: config.userconfig
                }
              });
            }
          })
          .catch((err) => console.log("LOGS: getConfig err", err));
      } catch (err) {
        console.log("LOGS: getConfig Error", err);
      }
    };

    setUpData = () => {
      this.getConfig();
      this.getInstConfig();
    };


    initApp = () => {
      window.flow = this.props.flow;
      window.flow
        .init()
        .then(() => {
          console.log("LOGS: INIT");
          if (process.env.REACT_APP_USER && process.env.REACT_APP_PASSWORD) {
            console.log("LOGS: LOGIN");
            window.flow
              .login(process.env.REACT_APP_USER, process.env.REACT_APP_PASSWORD)
              .then((res) => {
                console.log("LOGS: LOGIN res", res);
                this.setState({ user: res.user });
                this.setUpData();
              })
              .catch((err) => console.log("LOGIN ERROR: ", err));
          } else {
            this.setUpData();
          }
        })
        .catch((err) => console.log("LOGS: INIT ERROR err", err));
    };

    componentDidMount() {
      this.initApp();
    }

    render() {
      return (
        <IntlProvider
          locale={this.props.mediaObjects.lg}
          messages={data[this.props.mediaObjects.lg]}
          onError={() => { }}
        >
          <Router basename={this.state.baseName}>
            <Navigation />
            <main>
              <Routes>
                <Route path="/" exact element={<MainPage />} />
                <Route path={`${ConfigTypes.CLIP_PATH}/:id`} exact element={<MainPage />} />
                <Route path={`${ConfigTypes.WORK_PATH}/:workId`} exact element={<MainPage />} />
                <Route path={`${ConfigTypes.ITEM_PATH}/:itemId`} exact element={<MainPage />} />
                <Route path={`${ConfigTypes.WORKDETAILS_PATH}/:workdetailsId`} exact element={<MainPage />} />
                <Route path={`${ConfigTypes.OBJECTDETAILS_PATH}/:objectdetailsId`} exact element={<MainPage />} />
                <Route path={`${ConfigTypes.ITEMDETAILS_PATH}/:itemdetailsId`} exact element={<MainPage />} />
                <Route path={`${ConfigTypes.COLLECTION_PATH}/:priref`} exact element={<MainPage />} />
              </Routes>
            </main>
            {/* <Footer /> */}
          </Router>
        </IntlProvider>
      );
    }
  }
);

const mapStateToProps = (state) => ({
  mediaObjects: state.media.mediaObjects,
  appObjects: state.app.appObjects
});

const mapDispatchToProps = (dispatch) => ({
  updateMediaObjects: (obj) => dispatch(actions.updateMediaObjects(obj)),
  updateAppObjects: (obj) => dispatch(actions.updateAppObjects(obj)),
  updateConfigObjects: (obj) => dispatch(actions.updateConfigObjects(obj)),
  searchObjects: () => dispatch(actions.searchObjects()),
});

export default Flow.injectFlow(
  connect(mapStateToProps, mapDispatchToProps)(App)
);
